import React from 'react';
import styles from './EventScore.module.css';
import { convertToBengaliNumber } from '../../BannerPart3/helper';

const EventScore = ({ events, playerLeaderboardData,memoryMatchLeaderboardData }) => {
  const getPlayerDataForEvent = (eventId) => {
    return playerLeaderboardData?.find(data => data.event_id === eventId) || {
      User_Rank: '-',
      score: 0,
      round_number: 0
    };
  };

  return (
    <div className={styles.container}>
      <div className={styles.title}>ইভেন্ট স্কোর</div>
      <div className={styles.gridContainer}>
        {events.map((event) => {
          const playerData = getPlayerDataForEvent(event.id);
          let scoreDiv = (parseInt(event.id) === 134) ? `${convertToBengaliNumber(playerData.score)}` : `${convertToBengaliNumber(playerData.score)}/${convertToBengaliNumber(event.question_set)}`;

          return (
            <div key={event.id} className={styles.card}>
              <div className={styles.eventTitle}>{event.events}</div>
              <div className={styles.scoreContainer}>
                <div className={styles.score}>
                {scoreDiv}
                </div>
                <div className={styles.rank}>
                  Rank- {playerData.User_Rank === 0 ? '-' : playerData.User_Rank}
                </div>
              </div>
            </div>
          )
        })}
        {memoryMatchLeaderboardData.map((data)=>{
          return(
            <div key={data.id} className={styles.card}>
              <div className={styles.eventTitle}>MemoryMatch</div>
              <div className={styles.difficultyLevel}>{data.difficulty_level}</div>
              <div className={styles.totalTime}>{data.total_time}s</div>
              <div className={styles.rank}>Rank:{data.user_rank}</div>
            </div>
          )
        })}
      </div>
    </div>
  );
};

export default EventScore;
